var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "#DAEDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.094 8.75549L18.044 7.62549C17.784 6.47549 17.134 5.81549 17.134 5.81549C16.7449 5.42563 16.2827 5.11633 15.774 4.90529C15.2652 4.69426 14.7198 4.58563 14.169 4.58563C13.6182 4.58563 13.0728 4.69426 12.564 4.90529C12.0552 5.11633 11.5931 5.42563 11.204 5.81549L9.72399 7.29549L3.09399 0.255493C2.09399 4.25549 3.09399 8.25549 5.54399 11.4755L0.0939941 16.7555C0.0939941 16.7555 8.98399 18.7555 14.164 14.7055C16.924 12.5455 17.544 11.2855 17.934 9.95549L21.094 8.75549ZM15.804 8.97549C15.414 9.36549 14.774 9.36549 14.384 8.97549C14.2913 8.88298 14.2177 8.77309 14.1676 8.65212C14.1174 8.53114 14.0915 8.40146 14.0915 8.27049C14.0915 8.13952 14.1174 8.00984 14.1676 7.88887C14.2177 7.7679 14.2913 7.65801 14.384 7.56549C14.774 7.17549 15.414 7.17549 15.804 7.56549C16.194 7.95549 16.194 8.58549 15.804 8.97549Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.e0d47de906aa45162dd845a28f7765c9.svg";
export { ForwardRef as ReactComponent };